import React from 'react'

function ThankYou() {
  return (
    <div className='thank-you'>
        <h3>Thank <b>you</b> for reaching out!</h3>
        <p>Sharon will respond within 24 hours!</p>
    </div>
  )
}

export default ThankYou